<template>
  <div>
    <b-row>
      <b-col lg="12">

        <b-row>
          <b-col
            cols="3"
            style="margin-left: 550px;"
          >
            <b-form-group style="padding-right: 30px; margin-top: 54px;">
              <flat-pickr
                v-model="date.dateFrom"
                class="form-control"
                @input="graphTrafficLine"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <app-echart-line
              style="height: 350px;"
              :option-data="option"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, VBModal, BFormGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { Icon } from 'leaflet'
import AppEchartLine from '@/views/traffiscifi/detailfi2/garaphLineAG/AppEchartLineAG.vue'
import 'leaflet/dist/leaflet.css'
/* eslint-disable global-require */
// eslint-disable-next-line import/order
import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: {

    // BCard,
    BRow,
    BCol,
    // BEmbed,
    AppEchartLine,
    BFormGroup,
    flatPickr,
    // flatPickr,
    // BDropdown,
    // BDropdownItem,
    // BDropdownDivider,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      revenueGenerated: {},
      name: [],
      items: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      option: {
        xAxisData: [],
        grid: {
          left: '5%',
          right: '5%',
          bottom: '10%',
          top: '10%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        legend: {
          data: ['Phase1', 'Phase2', 'Phase3', 'Phase4'],
          textStyle: {
            color: '#fff',
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.5)',
            },
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.1)',
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.5)',
            },
          },
        },
        series: [
          {
            name: 'Phase1',
            type: 'line',
            showSymbol: true, // เปิดการแสดงจุด
            symbolSize: 8, // ขนาดจุด
            symbol: 'circle', // รูปแบบจุด
            smooth: 0.4,
            lineStyle: {
              color: '#2effc9',
              width: 3,
              shadowColor: 'rgba(255,107,107,0.5)',
              shadowBlur: 10,
            },
            itemStyle: {
              color: '#2effc9',
              borderColor: '#2effc9',
              borderWidth: 2,
              shadowColor: 'rgba(255,107,107,0.5)',
              shadowBlur: 10,
            },
            emphasis: {
              scale: true,
              itemStyle: {
                borderWidth: 3,
                borderColor: '#fff',
              },
            },
            data: [],
            z: 4,
          },
          {
            name: 'Phase2',
            type: 'line',
            showSymbol: true, // เปิดการแสดงจุด
            symbolSize: 8, // ขนาดจุด
            symbol: 'circle', // รูปแบบจุด
            smooth: 0.4,
            lineStyle: {
              color: '#24ffeb',
              width: 3,
              shadowColor: 'rgba(78,205,196,0.5)',
              shadowBlur: 10,
            },
            itemStyle: {
              color: '#24ffeb',
              borderColor: '#24ffeb',
              borderWidth: 2,
              shadowColor: 'rgba(78,205,196,0.5)',
              shadowBlur: 10,
            },
            emphasis: {
              scale: true,
              itemStyle: {
                borderWidth: 3,
                borderColor: '#fff',
              },
            },
            data: [],
            z: 3,
          },
          {
            name: 'Phase3',
            type: 'line',
            showSymbol: true, // เปิดการแสดงจุด
            symbolSize: 8, // ขนาดจุด
            symbol: 'circle', // รูปแบบจุด
            smooth: 0.4,
            lineStyle: {
              color: '#43BAFE',
              width: 3,
              shadowColor: 'rgba(255,230,109,0.5)',
              shadowBlur: 10,
            },
            itemStyle: {
              color: '#43BAFE',
              borderColor: '#43BAFE',
              borderWidth: 2,
              shadowColor: 'rgba(255,230,109,0.5)',
              shadowBlur: 10,
            },
            emphasis: {
              scale: true,
              itemStyle: {
                borderWidth: 3,
                borderColor: '#fff',
              },
            },
            data: [],
            z: 2,
          },
          {
            name: 'Phase4',
            type: 'line',
            showSymbol: true, // เปิดการแสดงจุด
            symbolSize: 8, // ขนาดจุด
            symbol: 'circle', // รูปแบบจุด
            smooth: 0.4,
            lineStyle: {
              color: '#80eeff',
              width: 3,
              shadowColor: 'rgba(152,251,152,0.5)',
              shadowBlur: 10,
            },
            itemStyle: {
              color: '#80eeff',
              borderColor: '#98FB98',
              borderWidth: 2,
              shadowColor: 'rgba(152,251,152,0.5)',
              shadowBlur: 10,
            },
            emphasis: {
              scale: true,
              itemStyle: {
                borderWidth: 3,
                borderColor: '#fff',
              },
            },
            data: [],
            z: 1,
          },
        ],
      },
      check: '',
      date: {
        wid: '',
        dateFrom: '',
      },
    }
  },
  computed: {
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.date.wid = this.$route.query.wid
    this.checkPhase()
    this.setToday()
    this.graphTrafficLine()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.graphTrafficLine()
    }, 300000)
  },
  methods: {
    graphTrafficLine() {
      axios
        .post('/getPieTrafficDetail1', this.date)
        .then(response => {
          this.resetChart()
          this.xAxisData = []
          this.xAxisData = response.data
          // console.log(12, this.option)
          this.xAxisData.forEach(value => {
            if (this.check === 4) {
              this.option.xAxisData.push(value.Period_Name)
              this.option.series[0].data.push(value.Phase1_PCU)
              this.option.series[1].data.push(value.Phase2_PCU)
              this.option.series[2].data.push(value.Phase3_PCU)
              this.option.series[3].data.push(value.Phase4_PCU)
              this.option.series[3].name = 'Phase4'
            }
          })
          this.xAxisData.forEach(value => {
            if (this.check === 3) {
              this.option.xAxisData.push(value.Period_Name)
              this.option.series[0].data.push(value.Phase1_PCU)
              this.option.series[1].data.push(value.Phase2_PCU)
              this.option.series[2].data.push(value.Phase3_PCU)
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
    },

    checkPhase() {
      axios
        .post('/checkPhaseTraffic', { wid: this.$route.query.wid })
        .then(response => {
          this.check = response.data[0].PhaseNo
        })
        .catch(error => {
          console.log(error)
        })
    },

    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const date = (`0${p.getDate()}`).slice(-2)
      const year = p.getFullYear()
      this.date.dateFrom = `${year}-${month}-${date}`
      // this.date.dateTo = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    },
    resetChart() {
      this.option.xAxisData.splice(0)
      this.option.series[0].data.splice(0)
      this.option.series[1].data.splice(0)
      this.option.series[2].data.splice(0)
      this.option.series[3].data.splice(0)
    },
  },
}
</script>

<style lang="scss" scoped >
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.pie-text1{
    width: 200px;
    position:absolute;
    margin: auto;
    left: 85%;
    right: 0;
    top: 25%;
    bottom: 0;
  }
.bg-color {
    color: #FF9999;
}

.table-responsive{
   font-size: 15px;
}
.table th{
   padding: 0.72rem;
}
.table td{
   padding: 0.72rem;
}
.vue2leaflet-map{
  &.leaflet-container{
    height: 200px;
  }
}
.leaflet-popup-content {
  margin: 10px 10px;
}
.leaflet-container a.leaflet-popup-close-button {
  padding: 0 0 0 0
}
.apexcharts-legend-text {
  color: rgb(210, 176, 255)
}

</style>
